import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { ClassroomCourse } from '@modules/course/classroom/models';
import { ConfigService } from '@core/services/config.service';
import { CountryStoreService } from '@shared/store/country-store/services/country.store.service';
import { Observable } from 'rxjs';
import { Country } from '@shared/models/country';
import { Multimedia } from '@shared/models/multimedia';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-template-course-card',
  templateUrl: './template-course-card.component.html',
  styleUrls: ['./template-course-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TemplateCourseCardComponent implements OnInit, OnChanges {
  @Input()
  public size: CourseCardSize = 'small';

  @Input()
  public classroom: ClassroomCourse;

  @Input()
  public href = '/';

  @Input()
  public bookmarkShow = false;

  courseCategoryName: string = '';

  translationScope = TRANSLATION_SCOPE;


  constructor(
    private configService: ConfigService,
    private countryStoreService: CountryStoreService,
    private cdr: ChangeDetectorRef
  ) {
    this.cdr.detach();
  }

  get baseCdnUrl(): string {
    const env = this.configService.getCurrent().env;

    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/';

      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/';

      default:
        return 'https://rssjoliv-dev.imgix.net/';
    }
  }

  ngOnInit(): void {}

  public getDefaultImage(mediaList: Multimedia[]): string {
    return mediaList.find((media) => media.default === true).url;
  }

  public getCountry(code: string): Observable<Country> {
    return this.countryStoreService.getCountryByCode(code);
  }

  private getCategoriesName(course: ClassroomCourse): string {
    if (course?.categories.length > 0) {
      const categoryName = course.categories.slice(0, 1)?.pop().title;
      return ((course.categories.length === 1) ? categoryName : `${categoryName} +${course.categories.length - 1}`);
    }
    return 'Kurs';
  }

  ngOnChanges(): void {
    this.cdr.reattach();
    this.courseCategoryName = this.getCategoriesName(this.classroom)

    setTimeout(() => {
      this.cdr.detach();
    });
  }
}

export type CourseCardSize = 'large' | 'medium' | 'small';
